/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Container, Grid } from '@mui/material';
import HeaderWithSidebar from '../HeaderWithSidebar';
import Link from '../../atoms/Link';
import { TopSection, OrganisationContainer, Title, OrgAvatar } from './style';
import Typography from '../../atoms/Typography';
import { useTranslation } from '../../../config/i18n';

const OpportunityDetailsTemplate = ({ children, title, background }) => {
  const { t } = useTranslation('organisations');
  return (
    <HeaderWithSidebar contentPadding={0}>
      <TopSection background={background}>
          <Container maxWidth="xl">
            <Grid container>
              <Grid item md={8} sm={12} xs={12} />
            </Grid>
          </Container>
      </TopSection>
      {title && (
        <Title variant="h2" align="center" gutterBottom>
          {title}
        </Title>
      )}
      {children}
    </HeaderWithSidebar>
  );
};

OpportunityDetailsTemplate.propTypes = {
  children: PropTypes.node.isRequired,
  opportunity: PropTypes.object.isRequired,
  title: PropTypes.string,
  background: PropTypes.string,
};

OpportunityDetailsTemplate.defaultProps = {
  title: undefined,
  background: '',
};

export default OpportunityDetailsTemplate;
